import classNames from 'classnames/bind';
import { DateFormat } from 'common/types';
import { days, stringifyDepartureMonths } from 'common/utils';
import { useSearchParamsContext } from 'contexts/searchParams';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  onClick(): void;
}

export default function DepartureDate({ className, onClick }: IProps) {
  const {
    searchParams: { itinerary, departureMonths },
  } = useSearchParamsContext();
  const isDateSelected = itinerary.every(({ departureDate }) => departureDate);

  return (
    <button
      type="button"
      className={cx(className, 'Date')}
      aria-selected={isDateSelected}
      data-event-nlog="click"
      data-event-area-code="rcm.depdate"
      onClick={onClick}
    >
      {isDateSelected
        ? itinerary
            .map(({ departureDate }) =>
              days(departureDate, DateFormat.YMD).format(DateFormat.DotMDd),
            )
            .join(' ~ ')
        : stringifyDepartureMonths(departureMonths)}
    </button>
  );
}
